import React from 'react';

import FormHeader from 'components/FormHeader';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import { useAppSelector } from 'hooks/useAppSelector';

const SentResetPasswordLink = () => {
  const { email } = useAppSelector((state) => state.account);

  return (
    <FormHeader
      title={`We have emailed a password reset link to ${email} if it exists in our system.`}
      percent={ProgressBarStatus.Failed}
    />
  );
};

export default SentResetPasswordLink;
